// ViewModalTypeCards.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import SelectInput from 'components/selectinput/SelectInput';

/**
 * ViewModalTypeCards
 *
 * Renders the view type selector.
 *
 * @param {array} options - Available view type options.
 * @param {string} selectedKey - Currently selected view type key.
 * @param {function} onSelect - Handler for selecting a view type.
 *
 * @returns {ReactNode} The rendered component.
 */
const ViewModalTypeCards = ({ options, selectedKey, onSelect }) => {

    // ----- RENDER ----- //

    return (

        <ModalField>

            <ModalLabel label="View Type" />
            <ModalHint hint="Select the type of view you want to create." />

            <SelectInput
              value={selectedKey}
              options={options}
              placeholder="Select a view type..."
              onValueChange={(nextValue) => onSelect(nextValue)}
            />

        </ModalField>

    );
};

// Dev Tools
ViewModalTypeCards.displayName = 'ViewModalTypeCards';

export default ViewModalTypeCards;
